import { Selector, State } from "./types";

function createSelector(getState: () => State): Selector {
  return {
    isCopyDocumentRequestFailure() {
      return getState().isFailure;
    },
    isCopyDocumentRequestPending() {
      return getState().isPending;
    },
    isCopyDocumentRequestSuccess() {
      return getState().isSuccessful;
    },
  };
}

export { createSelector };
